import React from "react";

export default function PlanBanner(props) {
  var plan = props.plan;
  var user = props.user;
  var colors = { pro: "#a07828", elite: "#5b8aaa", team: "#6b8f71", free: "#7a6e64" };
  var color = colors[plan] || colors.free;
  var label = plan === "free" ? "FREE PLAN" : plan.toUpperCase() + " PLAN";
  return (
    <div style={{ background: color + "12", borderBottom: "1px solid " + color + "33", padding: "10px 40px", display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: 11, color: color, letterSpacing: 1 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <div style={{ width: 7, height: 7, borderRadius: "50%", background: color }} />
        <strong>{label}</strong>
        {user && user.email && <span style={{ color: "#7a6e64", letterSpacing: 0 }}>· {user.email}</span>}
      </div>
      <button onClick={props.onSignOut} style={{ background: "transparent", border: "1px solid rgba(180,160,140,.3)", color: "#7a6e64", fontFamily: "inherit", fontSize: 10, letterSpacing: 1.5, padding: "5px 14px", borderRadius: 100, cursor: "pointer" }}>
        Sign Out
      </button>
    </div>
  );
}
